import { IconProps } from "../../types/genereal";
import { IconWrapper } from "../ui/IconWrapper";

export const DataSourceContactIcon = ({
  width = "20",
  height = "20",
  color = "#1F2932",
  opacity = "0.4",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.3334 9.16663C14.7167 9.16663 15.825 8.04996 15.825 6.66663C15.825 5.28329 14.7167 4.16663 13.3334 4.16663C11.95 4.16663 10.8334 5.28329 10.8334 6.66663C10.8334 8.04996 11.95 9.16663 13.3334 9.16663ZM6.66671 9.16663C8.05004 9.16663 9.15837 8.04996 9.15837 6.66663C9.15837 5.28329 8.05004 4.16663 6.66671 4.16663C5.28337 4.16663 4.16671 5.28329 4.16671 6.66663C4.16671 8.04996 5.28337 9.16663 6.66671 9.16663ZM6.66671 10.8333C4.72504 10.8333 0.833374 11.8083 0.833374 13.75V15.8333H12.5V13.75C12.5 11.8083 8.60837 10.8333 6.66671 10.8333ZM13.3334 10.8333C13.0917 10.8333 12.8167 10.85 12.525 10.875C13.4917 11.575 14.1667 12.5166 14.1667 13.75V15.8333H19.1667V13.75C19.1667 11.8083 15.275 10.8333 13.3334 10.8333Z"
          fill={color}
          fillOpacity={opacity}
        />
      </svg>
    </IconWrapper>
  );
};
